import { render } from "./templateGameListMaslenica.vue?vue&type=template&id=371204ba&scoped=true"
import script from "./templateGameListMaslenica.vue?vue&type=script&lang=js"
export * from "./templateGameListMaslenica.vue?vue&type=script&lang=js"

import "./templateGameListMaslenica.vue?vue&type=style&index=0&id=371204ba&scoped=true&lang=css"

import exportComponent from "/Users/konstantinkorobitsin/Work/ar-game-constructor/ar-game-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-371204ba"]])

export default __exports__